import React from 'react';
import { Chart } from "react-google-charts";
import { Row, Col, Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import '../../../../assets/css/graficoBarras.css'

export function GraficoBarras({ dados = [], handleVoltar }) {
    const data = [["Element", "Quantidade", { role: "style" }], ...dados];
    const options = {
        legend: "none",
        hAxis: {
            textStyle: {
                color: "#5C636A"
            }
        },
        vAxis: {
            textStyle: {
                color: "#5C636A"
            }
        },
        tooltip: {
            isHtml: true
        }
    };

    return (
        <>
            <div className='mb-3'>
                <Button color='secondary' className='text-white' onClick={handleVoltar}>
                    <FontAwesomeIcon icon={faArrowLeft} />
                    <span className='px-2'> Voltar </span>
                </Button>
            </div>
            <h4 className='text-secondary m-0'>Ranking de Fiscalizações</h4>
            <Row style={{ height: "65vh", backgroundColor: "#eee" }} className="mt-3 mb-5 rounded-3 overflow-hidden shadow" >
                <Col md="12" lg="12" className=' m-0 p-0'>
                    <Chart chartType="ColumnChart" width="100%" height="100%" data={data} options={options} />
                </Col>
            </Row>
        </>
    );
}